import { render } from "./TopBarRightHolder.vue?vue&type=template&id=a443bf0c&ts=true"
import script from "./TopBarRightHolder.vue?vue&type=script&lang=ts"
export * from "./TopBarRightHolder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__